import { Link, useLocation, useParams } from 'react-router'
import { useMediaQuery } from '@mantine/hooks'
import clsx from 'clsx'
import { useState, useMemo } from 'react'
import { TeamList, useAllTeams } from './api'
import Header from '../common/components/header/Header'
import TeamsPlayersHeader from '../common/components/header/TeamsPlayersHeader'
import Meta from '../common/Meta'
import TeamCard from './TeamCard'
import RowData from '../common/components/row/RowData'
import { LeaguestarState } from '../state'
import classes from './Teams.module.css'
import { Text } from '@mantine/core'
import { useCompetitionDetails } from '../navigation/api'

export default function Teams() {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const location = useLocation()
  const { competitionId } = useParams()
  const { data: teams } = useAllTeams({ competition_id: Number(competitionId) })
  const [searchValue, setSearchValue] = useState('')
  const { teams_layout } = LeaguestarState.useState((state) => ({
    teams_layout: state.teams_layout,
  }))
  const competitionDetails = useCompetitionDetails({
    competition_id: Number(competitionId),
  })

  const filteredTeams = useMemo(() => {
    if (!searchValue.trim()) return teams.items
    const search = searchValue.toLowerCase()
    return teams.items.filter((team) =>
      team.name.toLowerCase().includes(search)
    )
  }, [teams, searchValue])

  function setTeamsLayout(layout: 'grid' | 'list') {
    LeaguestarState.update((state) => {
      state.teams_layout = layout
    })
    localStorage.setItem('teams_layout', layout)
  }

  return (
    <div className={classes.container}>
      <Meta title="Teams" />
      <Header title="Teams" />
      <div
        className={clsx(classes.teams_wrapper, {
          [classes.teams_wrapper_mobile]: !isDesktop,
        })}
      >
        <TeamsPlayersHeader
          title="Teams"
          layout={teams_layout}
          setLayout={setTeamsLayout}
          searchValue={searchValue}
          onSearchChange={setSearchValue}
        />

        {teams_layout === 'grid' && (
          <div className={classes.teams_grid}>
            {filteredTeams.length > 0 ? (
              filteredTeams.map((team) => (
                <Link
                  key={team.team_id}
                  to={`/competitions/${competitionId}/teams/${team.team_id}/overview`}
                  state={{ from: location }}
                  className={classes.link}
                >
                  <TeamCard
                    key={team.team_id}
                    team={team}
                    isSinglePlayerTeam={
                      competitionDetails.data?.single_player_teams ?? false
                    }
                  />
                </Link>
              ))
            ) : (
              <Text
                size="sm"
                c="dimmed"
                style={{
                  gridColumn: '1 / -1',
                  textAlign: 'center',
                  padding: '2rem',
                }}
              >
                No teams found matching "{searchValue}"
              </Text>
            )}
          </div>
        )}

        {teams_layout === 'list' && (
          <div className={classes.teams_list}>
            {filteredTeams.length > 0 ? (
              filteredTeams.map((team: TeamList) => (
                <Link
                  key={team.team_id}
                  to={`/competitions/${competitionId}/teams/${team.team_id}/overview`}
                  state={{ from: location }}
                  className={classes.link}
                >
                  <RowData
                    team_logo={team.logo.thumbnail}
                    team_name={team.name}
                  />
                </Link>
              ))
            ) : (
              <Text
                size="sm"
                c="dimmed"
                style={{ textAlign: 'center', padding: '2rem' }}
              >
                No teams found matching "{searchValue}"
              </Text>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
